import { ArrowDropDown } from "@mui/icons-material";
import { Chip, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";

export default function ChipSelect({
  value,
  onChange,
  items,
  renderLabel,
  hideArrow,
  ...props
}) {
  const [open, setOpen] = useState({
    dropdown: false,
  });

  return (
    <>
      <Menu
        open={!!open.dropdown?.open}
        anchorEl={open.dropdown?.anchorElement}
        onClose={() => {
          setOpen({
            ...open,
            dropdown: {
              ...open.dropdown,
              open: false,
            },
          });
        }}
      >
        {items.map((item) => {
          return (
            <MenuItem
              onClick={() => {
                setOpen({
                  ...open,
                  dropdown: {
                    ...open.dropdown,
                    open: false,
                  },
                });
                onChange?.(item);
              }}
              selected={value == item.id}
              key={"CHIP DROPDOWN: " + item.id}
              sx={{ borderRadius: "6px", px: 1.5, py: 0.75 }}
            >
              {item.label}
            </MenuItem>
          );
        })}
      </Menu>
      <Chip
        color="info"
        label={
          renderLabel ? (
            renderLabel?.(
              items?.find((item) => item.id == value)?.label || "None",
            )
          ) : (
            <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
              {items?.find((item) => item.id == value)?.label || "None"}
            </Typography>
          )
        }
        size="small"
        onDelete={(e) => {
          setOpen({
            ...open,
            dropdown: {
              anchorElement: e.currentTarget,
              open: true,
            },
          });
        }}
        sx={{ color: "white !important" }}
        onClick={(e) => {
          setOpen({
            ...open,
            dropdown: {
              anchorElement: e.currentTarget,
              open: true,
            },
          });
        }}
        deleteIcon={
          <ArrowDropDown
            sx={{
              color: "white !important",
              width: hideArrow ? "0px" : "unset",
              display: hideArrow ? "none" : "auto",
            }}
          />
        }
        clickable
        {...props}
      />
    </>
  );
}
